import React, { useState } from "react";
import s from "./BookingProcess.module.scss";
import ImageWithPlaceholder from "../../components/Image/ImageWithPlaceholder";
import step1 from '../../assets/images/bookingSteps/step1.png';

const BookingSteps = ({ index, step, total }) => {

    const isEven = index % 2 === 0;
    const isLast = index === total - 1;

    return (
        <>
            <div className="row">

                {/* IMAGE */}
                <div className={`col-12 col-md-6 ${isEven ? "order-md-first" : "order-md-last"}`}>
                    <ImageWithPlaceholder
                        className={s.stepImage}
                        src={step.image}
                    />
                </div>

                {/* TEXT */}
                <div className="col-12 col-md-6">
                    <div className={s.stepsWrapper}>
                        <div className={s.stepNumber}>
                            {String(index + 1).padStart(2, "0")}
                            <span className={s.stepText}> Step</span>
                        </div>

                        <div className={s.stepTitle}>{step.title}</div>
                        <div
                            className={s.stepDescription}
                             >
                            {step.description.split('\n').map((line, index) => (
                                <p className={s.newLine} key={index}>{line}</p>

                            ))}
                        </div>

                    </div>
                </div>
            </div>

            {/* CONNECTOR */}
            {!isLast && (
                <div className={`row ${s.dashline}`}>
                    <div className="col-12">
                        <svg
                            className={`${s.connector} ${!isEven ? s.connectorReversed : ""}`}
                            viewBox="0 0 500 200"
                            preserveAspectRatio="none"
                        >
                            <path
                                d="M 100 0 Q 150 100 400 200"
                                fill="none"
                                stroke="black"
                                strokeWidth="3"
                                strokeDasharray="10, 10"
                            />
                        </svg>
                    </div>
                </div>
            )}
        </>
    );
};

export default BookingSteps;